/**
 * 资金流向
 */
import React from "react"
import { quote_item_name, single_quote } from "../../quotedata/index"

export function FundsFlow(props: { data: any }) {
  let data = {}
  if(props.data){
     data = {
      ...props.data,
      AmtNetMax:Math.max(Math.abs(props.data.f140), Math.abs(props.data.f143), Math.abs(props.data.f146), Math.abs(props.data.f149))
    }
  }
  return (
    <div className="pk-container">
      <p className="title_p">今日资金流向(万元)</p>
      <table className="zjlx_data" cellPadding="0" cellSpacing="0" width="100%">
        <thead>
          <tr>
            <th>主力流入</th>
            <th>主力流出</th>
            <th>主力净流入</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{single_quote[quote_item_name.主力流入](props.data).element}</td>
            <td>{single_quote[quote_item_name.主力流出](props.data).element}</td>
            <td>{single_quote[quote_item_name.主力净流向](props.data).element}</td>
          </tr>
        </tbody>
      </table>
      <table className="lrlch_data" cellPadding="0" cellSpacing="0" width="100%">
        <thead>
          <tr>
            <th></th>
            <th>流入</th>
            <th>流出</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>超大单</td>
            <td>{single_quote[quote_item_name.超大单流入](props.data).element}</td>
            <td>{single_quote[quote_item_name.超大单流出](props.data).element}</td>
          </tr>
          <tr>
            <td>大单</td>
            <td>{single_quote[quote_item_name.大单流入](props.data).element}</td>
            <td>{single_quote[quote_item_name.大单流出](props.data).element}</td>
          </tr>
          <tr>
            <td>中单</td>
            <td>{single_quote[quote_item_name.中单流入](props.data).element}</td>
            <td>{single_quote[quote_item_name.中单流出](props.data).element}</td>
          </tr>
          <tr>
            <td>小单</td>
            <td>{single_quote[quote_item_name.小单流入](props.data).element}</td>
            <td>{single_quote[quote_item_name.小单流出](props.data).element}</td>
          </tr>
        </tbody>
      </table>
      <div className="canvas_pic">
        <div className="up_div">
          <ul className="up_ul">
            {single_quote[quote_item_name.净超大流入](data).element}
            {single_quote[quote_item_name.净大单流入](data).element}
            {single_quote[quote_item_name.净中单流入](data).element}
            {single_quote[quote_item_name.净小单流入](data).element}
          </ul>
        </div>
        <div className="down_div">
          <ul className="down_ul">
            {single_quote[quote_item_name.净超大流出](data).element}
            {single_quote[quote_item_name.净大单流出](data).element}
            {single_quote[quote_item_name.净中单流出](data).element}
            {single_quote[quote_item_name.净小单流出](data).element}
          </ul>
        </div>
        <div className="date_div">
          <ul className="date_ul">
            <li>净超大</li>
            <li>净大单</li>
            <li>净中单</li>
            <li>净小单</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
